export const styleButton = {
  cursor: "pointer",
  color: "shadesOfDark.steel",
  ":hover": {
    backgroundColor: "shadesOfDark.whiteLight",
    borderRadius: "50%",
  },
};
